export default "__VITE_ASSET__9311e4b8__"